import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit"

//REDUCERS
import authReducer from "./authReducer";
import eventCategoryReducer from "./eventCategoryReducer";

const persistConfig = {
  key: "root",
  version: 1,
  storage
};

const reducer = combineReducers({
  authReducer,
  eventCategoryReducer
});

const persistedReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer
});